import { render, staticRenderFns } from "./VesselTrialTest.vue?vue&type=template&id=62427cd2&scoped=true&"
import script from "./VesselTrialTest.vue?vue&type=script&lang=js&"
export * from "./VesselTrialTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62427cd2",
  null
  
)

export default component.exports